import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { RelatedPartyEntityIndex } from '@funnels/types';
import { validatePhoneNumber } from '@funnels/utils';

import { MobileInputField } from '../../../Fields';

interface ContactLandlineNumberProps extends RelatedPartyEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const ContactLandlineNumber = ({ relatedPartyIndex, isOptional, isDisabled }: ContactLandlineNumberProps) => (
  <MobileInputField
    label="Landline number"
    name={FIELD_PATHS.RELATED_PARTY_LICENSED_BUILDER_LANDLINE(relatedPartyIndex)}
    validate={validatePhoneNumber('Please enter a valid landline number.', 'landline', isOptional)}
    isDisabled={isDisabled}
    isFullWidth
    className={PII_FIELD_MASKING_CLASS}
  />
);
